// @flow

import { combineReducers } from "redux";
import projectReducers from "./projectAdminReducers";
import resellerReducers from "./resellerReducers";
import quoteReducers from "./quoteAdminReducers";
import companyReducers from "./companyAdminReducers";
import userReducers from "./userAdminReducers";
import facebaseReducers from "./facebaseAdminReducers";
import licenceReducers from "./licenceAdminReducers";
import billingReducers from "./billingAdminReducers";

const reducers = combineReducers({
  project: projectReducers,
  reseller: resellerReducers,
  quote: quoteReducers,
  company: companyReducers,
  user: userReducers,
  facebase: facebaseReducers,
  licence: licenceReducers,
  billing: billingReducers
});

export default reducers;
